var AromaticNote = /** @class */ (function () {
    function AromaticNote(obj, id) {
        if (id) {
            this.id = id;
        }
        this.value = obj.value;
        this.en_value = obj.en_value;
        this.note_type = obj.note_type;
    }
    Object.defineProperty(AromaticNote.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AromaticNote.prototype, "Value", {
        get: function () {
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AromaticNote.prototype, "Envalu", {
        get: function () {
            return this.en_value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AromaticNote.prototype, "NoteType", {
        get: function () {
            return this.note_type;
        },
        enumerable: false,
        configurable: true
    });
    return AromaticNote;
}());
export { AromaticNote };
export function createAromaticNote(obj, id) {
    return new AromaticNote(obj, id);
}
export function createAromaticNotes(rawAromaticNotes) {
    var aromaticNotes = [];
    var rawAromaticNotesData = rawAromaticNotes.data;
    for (var _i = 0, rawAromaticNotesData_1 = rawAromaticNotesData; _i < rawAromaticNotesData_1.length; _i++) {
        var rawAromaticNote = rawAromaticNotesData_1[_i];
        var aromaticNote = createAromaticNote(rawAromaticNote.attributes, rawAromaticNote.id);
        aromaticNotes.push(aromaticNote);
    }
    return aromaticNotes;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/product/aromaticNote.ts
// module id = 113
// module chunks = 0